<template>
    <div class="app-user-context">
        <div class="app-user-context__avatar">
            <router-link :to="{ name: 'profile' }" class="complete-profile-reminder__rating-link">
                <common-user-avatar :user="$auth.getActiveMember()" :isCurrent="true" size="user-context"></common-user-avatar>
            </router-link>
            <div v-if="$auth.getActiveMember().newReferralsCount" class="app-user-context__notifications">
                <common-badge :content="$auth.getActiveMember().newReferralsCount"></common-badge>
            </div>
        </div>

        <h5 class="app-user-context__name">
            <common-user-name :user="$auth.getActiveMember()"></common-user-name>
        </h5>

        <p class="app-user-context__name">
            {{ practiceName }}
        </p>

        <p class="app-user-context__info">
            {{ $t('layouts.app.sidenav.current_physician') }}
        </p>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters({
                practice: 'auth/getPractice',
            }),

            practiceName() {
                return this.practice?.name
            },
        },
    }
</script>
